import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { InitAuth } from './features/auth/store/actions';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
    subscription: Subscription;
    constructor(private router: Router, private store: Store) {}

    ngOnInit() {
        this.subscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => window.scrollTo(0, 0));
        this.store.dispatch(InitAuth());
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
